<page-loading class="card_loading" *ngIf="loading"></page-loading>

<div class="body" *ngIf="!loading">
  <header>
    <h1 *ngIf="page < 3">Comprar</h1>
    <h1 *ngIf="page === 3">Finalizar Compra</h1>
    <h1 *ngIf="page === 4">Parabéns!</h1>

    <i icon="close" class="icons_close" (click)="chance('no')"></i>
  </header>

  <section *ngIf="page === 1">
    <h2>
      Gostaria de Comprar o Lote: <br />
      {{ auction.animal }}?
    </h2>
    <!-- create a select from 1 to len qtd -->

    <div class="card_select">
      <mat-select [(ngModel)]="qtd_choice">
        <mat-option *ngFor="let number of generateArray(qtd)" [value]="number">
          {{ number }}
        </mat-option>
      </mat-select>
    </div>

    <h1 class="modal-title">
      {{ auction.bid * qtd_choice | currency : 'BRL' }}
    </h1>
  </section>

  <section *ngIf="page === 2">
    <h2>Confirmar valor da compra</h2>
    <h1 class="modal-title">
      {{ auction.bid * qtd_choice | currency : 'BRL' }}
    </h1>
  </section>

  <section *ngIf="page === 3">
    <h2>Tem certeza dessa compra?</h2>
    <h1 class="modal-title">
      {{ auction.bid * qtd_choice | currency : 'BRL' }}
    </h1>
  </section>

  <section *ngIf="page === 4">
    <h2>Compra realizada com sucesso!</h2>
    <h1 class="modal-title">
      {{ auction.bid | currency : 'BRL' }}
    </h1>
  </section>

  <div class="card_buttons">
    <button mat-button class="btn_no" (click)="closePopup()">FECHAR</button>

    <button mat-button class="btn_yes" (click)="nextPage()" *ngIf="page === 1">
      SIM
    </button>
    <button mat-button class="btn_yes" (click)="nextPage()" *ngIf="page === 2">
      CONFIRMAR
    </button>
    <button mat-button class="btn_yes" (click)="finish()" *ngIf="page === 3">
      SIM
    </button>
  </div>
</div>
